// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__2dt1I","options":"AnswerScale_options__2YhqR","selected":"AnswerScale_selected__3RPyj"};